import React, { useState, useContext, useEffect } from 'react';
import DOMPurify from 'dompurify';
import BookerContext from '../../context/bookerContext';
import fieldParams from '../../const/fieldParams';
import '../../assets/styles/check-box.sass';
import { useValidatedInput } from '../../hooks/useValidatedInput';

const CheckBox = ({ fieldKey }) => {
  const { key, label, icon } = fieldParams[fieldKey];
  const context = useContext(BookerContext);
  const valueParams = {
    accessibleVehicle: {
      updateMethod: 'updateVehicle',
    },
    termsAndConditions: {
      updateMethod: 'updateTermsAndConditions',
    },
    keepSignedIn: {
      updateMethod: 'updateKeepSignedIn',
    },
  };

  const {
    state: {
      [fieldKey]: initState,
      [fieldKey]: { value: storedValue, required = fieldKey === 'termsAndConditions' } = {},
      isWebBooker,
      step,
    },
    [valueParams[fieldKey].updateMethod]: updateStoredValue,
  } = context;
  const labelText = typeof label === 'function' ? label(isWebBooker ? 'web' : '') : label;

  const [value, setValue] = useState(!!storedValue);
  const [setIsValid, setDoValidateForm, isFormValid, toggleBtnDisability] = useValidatedInput(
    'btn-view',
    !!storedValue,
  );

  useEffect(() => {
    if (!initState) updateStoredValue({ value, required });
  }, []);

  const onCheckboxChange = e => {
    const {
      target: { checked },
    } = e;
    setValue(checked);
    updateStoredValue({ value: checked, required });
    setIsValid(required && checked);

    if (!isWebBooker && step === 4) {
      toggleBtnDisability(!checked);
    }
  };

  return (
    <div className={`form-group form-group-${key} form-check`}>
      <label {...(icon && { 'data-image': icon })}>
        <input
          type="checkbox"
          name={key}
          checked={value}
          onChange={onCheckboxChange}
          className={`form-check-input${key === 'termsAndConditions' ? ' terms-conditions-check' : ''}`}
        />
        <span
          {...(key === 'termsAndConditions' && { className: 'terms' })}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(labelText) }}
        />
      </label>
    </div>
  );
};

export default CheckBox;
